<button
  type="button"
  class="event-button"
  [class.event-button--full]="size() === 'full'"
  [class.event-button--size-3-5]="size() === '3.5'"
  [class.event-button--size-2-5]="size() === '2.5'"
  [class.event-button--size-1-2-5]="size() === '1.25'"
  [class.event-button--disabled]="disabled()"
  [class.event-button--loading]="loading()"
  [style.width]="width()"
  [disabled]="disabled() || loading()"
  (click)="buttonClick.emit($event)"
>
  <div
    class="event-button__content tw-flex tw-items-center tw-justify-center"
    [class.tw-invisible]="loading()"
  >
    <ng-content></ng-content>
  </div>
  @if (loading()) {
    <div class="tw-absolute tw-inset-0 tw-flex tw-items-center tw-justify-center">
      <app-ui-kit-spinner />
    </div>
  }
</button>
